// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { useParams } from "react-router-dom";
// import "./BlogReadMore.css";
// import Gfooter from "../Component/Gfooter";

// function BlogReadMore() {
//   const { id } = useParams();
//   const [blog, setBlog] = useState(null);
//   const [selectedImageIndex, setSelectedImageIndex] = useState(null);
//   const [multiImages, setMultiImages] = useState([]);

//   useEffect(() => {
//     const fetchBlogDetail = async () => {
//       try {
//         const formData = new FormData();
//         formData.append("id", id);

//         const response = await axios.post(
//           "https://cyberathon.com/NLF/index.php/Api/Nlf_Controller/get_by_id_blog_card",
//           formData
//         );

//         if (response.data.status === true) {
//           const blogData = response.data.data;
//           setBlog(blogData);

//           // 🔥 Handle multi images safely
//           if (Array.isArray(blogData.multi_image)) {
//             setMultiImages(blogData.multi_image);
//           } else if (typeof blogData.multi_image === "string") {
//             setMultiImages(blogData.multi_image.split(","));
//           } else {
//             setMultiImages([]);
//           }
//         }
//       } catch (error) {
//         console.error("Error fetching blog detail:", error);
//       }
//     };

//     fetchBlogDetail();
//   }, [id]);

//   if (!blog) return <div className="text-center py-5">Loading...</div>;

//   const fullImageURLs = multiImages.map(
//     (img) => `https://cyberathon.com/NLF/${img}`
//   );

//   return (
//     <>
//       <section className="blog-read-section">
//         <div className="container">

//           {/* TITLE */}
//           <h1 className="blog-read-title mt-5">{blog.title}</h1>

//           {/* DESCRIPTION */}
//           <div
//             className="blog-read-description text-justify"
//             dangerouslySetInnerHTML={{ __html: blog.description }}
//           />

//           {/* MAIN IMAGE */}
//           {/* <div className="blog-main-image">
//             <img
//               src={`https://cyberathon.com/NLF/${blog.blog_image}`}
//               alt={blog.title}
//             />
//           </div> */}

//           {/* MULTI IMAGES (1 Row 5 Images) */}
//           {fullImageURLs.length > 0 && (
//             <div className="blog-multi-image-box">
//               {fullImageURLs.slice(0, 5).map((img, index) => (
//                 <div
//                   key={index}
//                   className="blog-multi-img-item"
//                   onClick={() => setSelectedImageIndex(index)}
//                 >
//                   <img src={img} alt="blog" />
//                 </div>
//               ))}
//             </div>
//           )}
//         </div>
//       </section>

//       {/* IMAGE MODAL */}
//       {selectedImageIndex !== null && (
//         <div
//           className="blog-image-modal"
//           onClick={() => setSelectedImageIndex(null)}
//         >
//           <img
//             src={fullImageURLs[selectedImageIndex]}
//             alt="expanded"
//           />
//         </div>
//       )}

//       <Gfooter />
//     </>
//   );
// }

// export default BlogReadMore;

import { Helmet } from 'react-helmet-async';
import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import "./BlogReadMore1.css";
import Gfooter from "../Component/Gfooter";

function BlogReadMore() {
  const { id } = useParams();
  const [blog, setBlog] = useState(null);
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);
  const [multiImages, setMultiImages] = useState([]);

  useEffect(() => {
    const fetchBlogDetail = async () => {
      try {
        const formData = new FormData();
        formData.append("id", id);

        const response = await axios.post(
          "https://cyberathon.com/NLF/index.php/Api/Nlf_Controller/get_by_id_blog_card",
          formData
        );

        if (response.data.status === true) {
          const blogData = response.data.data;
          setBlog(blogData);

          if (Array.isArray(blogData.multi_image)) {
            setMultiImages(blogData.multi_image);
          } else if (typeof blogData.multi_image === "string") {
            setMultiImages(blogData.multi_image.split(","));
          } else {
            setMultiImages([]);
          }
        }
      } catch (error) {
        console.error("Error fetching blog detail:", error);
      }
    };

    fetchBlogDetail();
  }, [id]);

  if (!blog) return <div className="text-center py-5">Loading...</div>;

  const fullImageURLs = multiImages.map(
    (img) => `https://cyberathon.com/NLF/${img}`
  );

  return (
    <>
      <Helmet>
        <title>{blog.title} | NLF Solutions</title>
        <meta
          name="description"
          content={(() => {
            const d = document.createElement('div');
            d.innerHTML = blog.description;
            return (d.innerText || 'Read the latest insights from NLF Solutions.').substring(0, 155);
          })()}
        />
        <link rel="canonical" href={`https://nlfs.in/blog/${id}`} />
      </Helmet>

      <section className="blog-read-section">
        <div className="container">

          {/* TITLE */}
          <h1 className="blog-read-title mt-5">{blog.title}</h1>

          {/* DESCRIPTION */}
          <div
            className="blog-read-description text-justify"
            dangerouslySetInnerHTML={{ __html: blog.description }}
          />

          {/* Description ke neeche, images se pehle — ya page ke end me */}
          <div className="container mt-4">
            <Link to="/blog" style={{ textDecoration: 'none' }}>
              <button style={{
                backgroundColor: '#e30613',
                color: '#fff',
                border: 'none',
                padding: '10px 25px',
                borderRadius: '30px',
                fontWeight: 'bold'
              }}>
                ← Back to Blogs
              </button>
            </Link>
          </div>

          {/* ONLY FIRST 5 IMAGES ON PAGE */}
          {fullImageURLs.length > 0 && (
            <div className="blog-multi-image-box">
              {fullImageURLs.slice(0, 5).map((img, index) => (
                <div
                  key={index}
                  className="blog-multi-img-item"
                  onClick={() => setSelectedImageIndex(index)}
                >
                  <img src={img} alt="blog" />
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* MODAL (All Images Accessible) */}
      {/* {selectedImageIndex !== null && (
        <div
          className="blog-image-modal"
          onClick={() => setSelectedImageIndex(null)}
        >
          
          <button
            className="modal-arrow left"
            onClick={(e) => {
              e.stopPropagation();
              setSelectedImageIndex(
                selectedImageIndex === 0
                  ? fullImageURLs.length - 1
                  : selectedImageIndex - 1
              );
            }}
          >
            ❮
          </button>

          <img
            src={fullImageURLs[selectedImageIndex]}
            alt="expanded"
          />

         
          <button
            className="modal-arrow right"
            onClick={(e) => {
              e.stopPropagation();
              setSelectedImageIndex(
                selectedImageIndex === fullImageURLs.length - 1
                  ? 0
                  : selectedImageIndex + 1
              );
            }}
          >
            ❯
          </button>

          <span
            className="modal-close"
            onClick={(e) => {
              e.stopPropagation();
              setSelectedImageIndex(null);
            }}
          >
            ✕
          </span>
        </div>
      )} */}
      {selectedImageIndex !== null && (
        <div
          className="blog-image-modal"
          onClick={() => setSelectedImageIndex(null)}
        >
          <div
            className="modal-content-wrapper"
            onClick={(e) => e.stopPropagation()}
          >
            {/* LEFT */}
            <button
              className="modal-arrow left"
              onClick={() =>
                setSelectedImageIndex(
                  selectedImageIndex === 0
                    ? fullImageURLs.length - 1
                    : selectedImageIndex - 1
                )
              }
            >
              ❮
            </button>

            {/* IMAGE */}
            <img
              src={fullImageURLs[selectedImageIndex]}
              alt="expanded"
            />

            {/* RIGHT */}
            <button
              className="modal-arrow right"
              onClick={() =>
                setSelectedImageIndex(
                  selectedImageIndex === fullImageURLs.length - 1
                    ? 0
                    : selectedImageIndex + 1
                )
              }
            >
              ❯
            </button>

            {/* CLOSE */}
            {/* <span
        className="modal-close"
        onClick={() => setSelectedImageIndex(null)}
      >
        ✕
      </span> */}
          </div>
        </div>
      )}

      <Gfooter />
    </>
  );
}

export default BlogReadMore;